import { ContextMenuItem } from "lib/@components/context-menu-bar/context-menu-item"
import { useDialog } from "lib/@hooks/useDialog"
import { useDemand } from "lib/authorization/use-demand"
import { isLockedToLegacy } from "authoring/lib/enum/project-phase.mjs"
import {
    AUTHORING_ARCHIVE_INCOMPLETE_WORK_PACKAGES_DEMAND,
    AUTHORING_ARCHIVE_WORK_PACKAGES_DEMAND,
} from "authoring/lib/constants/authoring-permissions.mjs"
import { ArchiveWorkPackageDialog } from "authoring/routes/project/components/archive-work-package-dialog"
import { toggleProjectArchive } from "authoring/routes/project/lib/toggle-project-archive"

export function ArchiveProjectMenuItem({ project }) {
    const canArchive = useDemand(AUTHORING_ARCHIVE_WORK_PACKAGES_DEMAND)
    const canArchiveIncomplete = useDemand([
        AUTHORING_ARCHIVE_WORK_PACKAGES_DEMAND,
        AUTHORING_ARCHIVE_INCOMPLETE_WORK_PACKAGES_DEMAND,
    ])
    const archived = !!project?.archived
    const incomplete = !archived && !isLockedToLegacy(project?.phase)
    const dialog = useDialog(
        <ArchiveWorkPackageDialog value={project?.id} archived={archived} incomplete={incomplete} />
    )
    const icon = archived ? "material-symbols:unarchive-outline" : "material-symbols:archive-outline"
    const label = archived ? "Restore" : "Archive"

    if (!canArchive) return null
    if (incomplete && !canArchiveIncomplete) return null

    return <ContextMenuItem icon={icon} label={label} onClick={handleClick} />

    function handleClick() {
        return toggleProjectArchive({ project, dialog })
    }
}
